import styled from "styled-components";

interface ModalTitileProps {
  readonly modalTheme: string;
}

export const StyledTitle = styled.div<ModalTitileProps>`
  max-width: 100%;
  text-align: center;
  margin-top: 0.3em;
  color: ${(props) => handlerColorTheme(props.modalTheme)};
`;

const handlerColorTheme = (theme: string) => {
  switch (theme) {
    case "primary":
      return "#000";

    case "secondary":
      return "#fff";

    default:
      return "#000";
  }
};

StyledTitle.defaultProps = {};
